import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/AdminOrderProductPaymentManagement';

const getAllOrderProductReducer = handleActions({
    [Actions.getAllOrderProductRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getAllOrderProductRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getAllOrderProductRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.clearOrderProductData]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const getDetailOrderProductReducer = handleActions({
    [Actions.getDetailOrderProductRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getDetailOrderProductRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getDetailOrderProductRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.clearDetailOrderProductData]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateStatusTransactionReducer = handleActions({
    [Actions.updateStatusTransactionRequested]: (state) => ({
        ...state,
        isFetching: true,
        isSuccess: false,
    }),
    [Actions.updateStatusTransactionRequestedReceived]: (state) => ({
        ...state,
        isFetching: false,
        isSuccess: true,
    }),
    [Actions.updateStatusTransactionRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isSuccess: false,
        errors: action.payload.errors,
    }),
    [Actions.clearStatusTransaction]: () => ({
        isFetching: false,
        isSuccess: false,
        errors: {},
    }),
}, {
    isFetching: false,
    isSuccess: false,
    errors: {},
});

const resentMailOrderReducer = handleActions({
    [Actions.resentMailOrderRequested]: (state) => ({
        ...state,
        isFetching: true,
        isSuccess: false,
    }),
    [Actions.resentMailOrderRequestedReceived]: (state) => ({
        ...state,
        isFetching: false,
        isSuccess: true,
    }),
    [Actions.resentMailOrderRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isSuccess: false,
        errors: action.payload.errors,
    }),
    [Actions.clearMailOrder]: () => ({
        isFetching: false,
        isSuccess: false,
        errors: {},
    }),
}, {
    isFetching: false,
    isSuccess: false,
    errors: {},
});

export default combineReducers({
    getAllOrder: getAllOrderProductReducer,
    getDetailOrder: getDetailOrderProductReducer,
    updateStatus: updateStatusTransactionReducer,
    resentMail: resentMailOrderReducer,
});
